import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { EnfermeiroService } from '../../enfermeiro.service';
import { AlertsService } from 'app/shared/alerts.service';
import { FormGroup } from '@angular/forms';
import { Paciente, CartaoGestante } from 'app/core/interfaces/pacient-info.interface';
import { ModalsService } from 'app/shared/modals.service';
import { APIGestaCardService } from 'app/core/api/gestacard.service';
import { Enfermeiro } from 'app/core/interfaces/enfermeiro.interface';
import { Organizacao } from 'app/core/interfaces/organizacao.interface';
import { logger } from '../../../../core/utils/console';

@Component({
  selector: 'app-enfermeiro-alterar-paciente',
  templateUrl: './enfermeiro-alterar-paciente.component.html',
  styleUrls: ['./enfermeiro-alterar-paciente.component.scss']
})
export class EnfermeiroAlterarPacienteComponent implements AfterViewInit {

  loading = true; 
  paciente_id: string; 
  paciente: Paciente; 
  enfermeiro: Enfermeiro = Enfermeiro.createEmpty();
  organizacao: Organizacao = Organizacao.createEmpty();
  oldPage: number;

  emails_medicos: string[] = [];
  emails_enfermeiros: string[] = [];
  edit_paciente = false;

  form: FormGroup; 

  @ViewChild('imageUploader') image_uploader; 
  @ViewChild('cadastro_paciente') componente_cadastro_paciente; 
  
  constructor(
    private router: Router, 
    private enfermeiroService: EnfermeiroService, 
    private snackService: AlertsService, 
    private modalService: ModalsService, 
    private _apigestacard: APIGestaCardService, 
    private cdr: ChangeDetectorRef,
  ) {

    try {

      const navigation = this.router.getCurrentNavigation();

      if (navigation && navigation.extras && navigation.extras.state) {
        const state = navigation.extras.state;
        if (state.paciente && state.id) {
          this.paciente_id = state.id; 
          this.oldPage = state.oldPage || 1;
        } else {
          this.router.navigateByUrl('/enfermeiro');
        }
      } else {
        this.router.navigateByUrl('/enfermeiro');
      }

    } catch(err) {

      logger.log('EnfermeiroAlterarPacienteComponent -> constructor -> err', err);
      this.router.navigateByUrl('/enfermeiro');

    }

  }

  ngAfterViewInit() {

    this.form = this.componente_cadastro_paciente.form; 
    
    this.BuscarDados();
  
  }

  BuscarDados() {
    this.enfermeiroService.GetListaEmailsEnfermeiros().subscribe((res) => {
      this.emails_enfermeiros = res; 
    });

    this.enfermeiroService.GetUserData().subscribe((res) => {
      this.enfermeiro = res;

      this.enfermeiroService.GetOrgData().subscribe((org) => {
        this.organizacao = org;
        this.cdr.detectChanges();

        if (this.paciente_id) {
          this.enfermeiroService.GetPacientePorIdObs(this.paciente_id).subscribe((res) => {
            if ('qual_plano' in res) { res['qual_plano'] = res['qual_plano'].toUpperCase(); }
            
            this.paciente = res; 

            this.AtualizarFormulario();
          });
        }
      })
    });
  }

  AtualizarFormulario() {
    if (!this.paciente) return;

    this.form.patchValue(this.paciente); 
    this.form.controls.cns.disable(); 
    if (this.form.controls.cpf.value) this.form.controls.cpf.disable(); 

    this.form.removeControl('enfermeiro_app'); 
    this.form.removeControl('medico_app');
          
    if (this.paciente.enfermeiro_app === this.enfermeiro.id || this.organizacao.instituicao_publica === 'S') {
      this.edit_paciente = true;
    }
    
    if (this.organizacao.instituicao_publica === 'N') {
      this.form.removeControl('cns');

      if (this.paciente.enfermeiro_app !== this.enfermeiro.id) this.form.disable();
    }

    this.loading = false;
  }

  async Alterar() {

    if (this.form.valid) {

      var novo_objeto_paciente = { ...this.paciente, ...this.form.getRawValue() };

      // Salvar o dado no db
      if (this.image_uploader.foto_mudou) {

        try {

          var imagem = this.image_uploader.imagePath;
          var image_to_upload = imagem[0];
          var url_imagem = await this._apigestacard.UploadImage(image_to_upload);

          novo_objeto_paciente['url'] = url_imagem;

        } catch(err) {

          this.snackService.SnackMessage('Erro ao atualizar a imagem do paciente'); 
          return; 

        }

      }

      delete novo_objeto_paciente['cartao_gestante'];

      if (!novo_objeto_paciente['cpf']) delete novo_objeto_paciente['cpf'];

      this.enfermeiroService.AtualizarPaciente(novo_objeto_paciente).then((res) => {

        this.snackService.SnackMessage('Paciente atualizado com sucesso!');

        const navigationExtras: NavigationExtras = {
          state: {
            page: this.oldPage,
          }
        };

        this.router.navigate(['/enfermeiro'], navigationExtras); 

      }).catch((err) => {

        this.snackService.SnackMessage('Erro ao atualizar o paciente'); 

      })

    } else {
      let errors: Array<string> = [];
      let error = 'Por favor, verifique os campos e tente novamente.';
      
      Object.keys(this.form.controls).forEach(controlName => {
        const control = this.form.get(controlName);

        if (control && control.errors) Object.keys(control.errors).forEach(errorKey => {
          errors.push(`Campo ${controlName} ${errorKey}`);
        });
      });

      if (errors.length > 0) error += ' Erros encontrados: ' + errors.join(', ');

      this.snackService.SnackMessage(error);
    }

  }

  AbrirCartaoGestante(cartao: CartaoGestante|null, cartao_id: string, paciente_id: string) {
     
    var navigationExtras: NavigationExtras;
    
    if (cartao != null) {

      navigationExtras = {
        state: {
          cartao_id:  cartao.id, 
          paciente_id: this.paciente_id
        }
      }; 

    } else {

      navigationExtras = {
        state: {
          cartao_id,
          paciente_id
        }
      };
      
    }

    this.router.navigate(['/enfermeiro-alterar-cartao-gestante'], navigationExtras);

  }

  AdicionarNovoCartao() {     
    if (!this.paciente || !this.paciente.id) {
      this.snackService.SnackMessage('Paciente não encontrado, recarregue a página e tente novamente');
      return;
    }

    this.enfermeiroService.AdicionarCartaoAoPaciente(this.paciente.id)
      .then((res) => {
        if (!res || !res.id) {
          this.snackService.SnackMessage('Erro ao adicionar o cartão, tente novamente');
          return;
        }
        
        this.snackService.SnackMessage("Cartão adicionado com sucesso");
        //this.BuscarPaciente(this.paciente_id);  
        this.AbrirCartaoGestante(null, res.id, this.paciente.email); 

      })
      .catch(err => this.snackService.SnackMessage(err)); 
  }

  DeletarPaciente() {
    this.modalService.AbrirModalDeConfirmacao('Excluir Paciente', 'Tem certeza que deseja excluir esse paciente? Essa ação não poderá ser desfeita!, deseja continuar?').subscribe((res: boolean) => {
      if (res) {
        this.enfermeiroService.DeletarPaciente(this.paciente.email, this.paciente_id).then((res) => {
          this.snackService.SnackMessage('Usuario excluido com sucesso!'); 

          const navigationExtras: NavigationExtras = {
            state: {
              page: this.oldPage,
            }
          };

          this.router.navigate(['/enfermeiro'], navigationExtras); 
        });
      }
    });
  }

  ResetPassword() {

    this.modalService.AbrirModalDeConfirmacao('Redefinir Senha', 'Confirma o envio do link de redefinição de senha para o usuário, no email  ' + this.paciente.email + '?').subscribe((res: boolean) => {
      if (res) {
      this.enfermeiroService.EmailResetPaciente(this.paciente.email).then((res) => {
        this.snackService.SnackMessage('Link de definição de senha enviado para o e-mail da paciente: ' + this.paciente.email);

        const navigationExtras: NavigationExtras = {
          state: {
            page: this.oldPage,
          }
        };
        
        this.router.navigate(['/enfermeiro'], navigationExtras); 
      });
      }
    });

  }

  Voltar() {
    const navigationExtras: NavigationExtras = {
      state: {
        page: this.oldPage,
      }
    };

    this.router.navigate(['/enfermeiro'], navigationExtras);
  }

}
